import React, { useState } from 'react';
import { Box, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { AppColors } from '../../../Utils/helper/AppColors';
import UserThumbnail from '../../../Components/User/UserThumbnail';
import DepartmentTag from '../../../Components/DepartmentTag';
import CustomTag from '../../../Components/CustomTag';
import dayjs from 'dayjs';
import PlayingModal from '../../Recordings/Components/PlayingModal';
import { PlayCircleIcon } from '../../../Components/Icons/Icons';
import { USER_TYPE } from '../../../Utils/helper/AppConstants';
import DataNotFound from '../../../Components/DataNotFound';
import moment from 'moment';
import CustomTablePagination from '../../../Components/CustomTablePagination';

export default function ExitInterviewTable({ list , getList , pagination}) {
	const [selected, setSelected] = useState(null);

	return (
		<>
			<TableContainer sx={{ backgroundColor: AppColors.WHITE, borderRadius: '12px' ,  height: 'calc(100vh - 550px)' ,  }}>
				{
				
				(<Table stickyHeader>
					<TableHead
						sx={{
							'& .MuiTableCell-root': {
								fontSize: 14,
								lineHeight: '150%',
								letterSpacing: '0%',
								fontFamily: 'Poppins',
								color: AppColors.midnight_black || AppColors.HEADING_TITLE2,
								fontWeight: 600,
								paddingTop: '16px',
								paddingBottom: '20px',
							},
						}}
					>
						<TableRow>
							<TableCell sx={{minWidth : '150px' , width : '200px'}}>Employee Detail</TableCell>
							<TableCell sx={{minWidth : '300px' , width : '320px'}}>Call Summary</TableCell>
							<TableCell sx={{minWidth : '100px' , width : '150px'}}>Department</TableCell>
							<TableCell sx={{minWidth : '115px' , width : '150px'}}>Exit Date</TableCell>
							<TableCell sx={{minWidth : '100px' , width : '150px'}}>Recording</TableCell>
							<TableCell sx={{minWidth : '175px' , width : '175px'}}>Sentiment Score</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{list?.length === 0 ? (
							<TableRow>
							   <TableCell colSpan={6} sx={{ py: 6 }}>
							         <DataNotFound text="No data found" size={150} />
							   </TableCell>
							</TableRow>
						) : (
							<>
								{list?.map((c, index) => (
									<TableRow
										sx={{
											'& .MuiTableCell-root': {
												paddingTop: '10px',
												paddingBottom: '10px',
											},
										}}
										key={index}
									>
										<TableCell>
											<Stack direction="column" alignItems="start">
												<UserThumbnail noPagination={true} user={{ firstName: c?.name }} />
												<Typography variant="subtitle2">{c?.user?.email}</Typography>
												<Typography variant="subtitle2">{c?.user?.phoneNumber}</Typography>
											</Stack>
										</TableCell>
										<TableCell>
											<Typography variant="subtitle2">{c?.callSummary?.summary || 'N/A'}</Typography>
										</TableCell>
										<TableCell>
											<CustomTag
												tagTitle={c?.department}
												colorsInfo={{
													color: AppColors.midnight_black,
													bgColor: AppColors.lightest_grey,
													border: AppColors.light_grey,
												}}
												fontSize={14}
												fontWeight={600}
												lineHeight={'150%'}
												px={12}
												py={2}
											/>
										</TableCell>
										<TableCell>
											<Typography variant="subtitle2">{c?.call?.updatedAt  ? moment(c?.call?.updatedAt ).format('MM-DD-YYYY') : ''}</Typography>
										</TableCell>
										<TableCell>
											<Stack
												sx={{
													cursor: c?.name === USER_TYPE.ANONYMOUS ? 'auto' : 'pointer',
													opacity: c?.name === USER_TYPE.ANONYMOUS ? 0.2 : 1,
												}}
												onClick={() => {c?.name !== USER_TYPE.ANONYMOUS && setSelected(c);}} 
												direction="row"
												alignItems="center"
												gap={0.5}
											>
												<PlayCircleIcon color={AppColors?.tomato_orange} size={28} />
												<Typography
													fontFamily={'Poppins'}
													fontSize={14}
													fontWeight={600}
													lineHeight={'150%'}
													sx={(theme) => ({
														color: theme.palette.primary.darker_primary,
													})}
													whiteSpace="nowrap"
												>
													Recording {index + 1}
												</Typography>
											</Stack>
										</TableCell>
										<TableCell>
											<Typography variant="subtitle2">{c?.callSummary?.score ? Math.round(c?.callSummary?.score/10) + '/10'  :  'N/A'}</Typography>
										</TableCell>
									</TableRow>
								))}

								{list?.length > 0 && (
									<TableRow
										sx={{
											position: 'sticky',
											bottom: 0,
											backgroundColor: '#fff',
											zIndex: 2,
										}}
									>
										<TableCell sx={{ paddingY: '4px' }} colSpan={12} align="center">
											<CustomTablePagination
												{...pagination}
												onChange={(p, r) => getList(p, r)}
												onRowsPerPageChange={(e) => getList(1, e.target.value)}
											/>
										</TableCell>
									</TableRow>
								)}
							</>
						)}
					</TableBody>
					
				</Table>)}		
			</TableContainer>
			<PlayingModal open={Boolean(selected)} onClose={() => setSelected(null)} selected={selected} />
		</>
	);
}
